var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noticeContainer"},[_c('div',{staticClass:"noticeIcon",on:{"click":_vm.openPopup}},[_c('van-badge',{attrs:{"content":_vm.msgList.length}},[_c('img',{attrs:{"src":require("@/assets/icons/icon_alarm.png")}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }